var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-block",attrs:{"title":"Pending approval","theme":"warning"}},[_vm._v(" "+_vm._s(_vm.pendingText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }